import Crud from "./Crud";
import Endpoints from "../constants/Endpoints";

export default Crud(Endpoints.payees, '0')
